<div class="icon">
  <ng-content select="glxy-confirmation-icon, [glxyConfirmationIcon]" />
</div>

<ng-content select="glxy-confirmation-title, [glxyConfirmationTitle]" />

<ng-content select="glxy-confirmation-message, [glxyConfirmationMessage]" />

<ng-content select="glxy-confirmation-custom-content, [glxyConfirmationCustomContent]" />
